export default "__VITE_ASSET__By07DXK8__"